<!--
  批量编辑
 -->

<template>
  <div class="batch-edit">
    <el-dialog title="批量编辑" width="700px" :visible.sync="dialogVisible">
      <el-form label-width="140px" class="custom-form">
        <el-form-item label="选择编辑字段:">
          <el-select
            v-model="fillterAlias"
            @change="changeFillter(fillterAlias)">
              <el-option
                v-for="(option, index) in fillterDate"
                :key="option.alias+index"
                :value="option.alias"
                :label="option.name">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="fillter.name" :label="fillter.name+':'" required>
          <el-select
          filterable
            v-if="fillter.fieldType===3 && fillter.isRedundant === 1"
            v-model="attrValue"
            >
            <el-option
              v-for="arr in fillter.filterArray"
              :key="arr"
              :label="arr"
              :value="arr">
            </el-option>
          </el-select>
          <el-select
            v-else-if="(fillter.fieldType === 3 || fillter.fieldType === 10) && fillter.isRedundant === 0"
            v-model="attrValue"
            >
            <el-option
              v-for="arr in fillter.filterArray"
              :key="arr.key"
              :label="arr.value"
              :value="arr">
            </el-option>
          </el-select>
          <!-- 日期选择 -->
          <el-date-picker
            v-else-if="fillter.fieldType === 4"
            type="date"
            placeholder="选择日期"
            :editable="false"
            v-model="attrValue"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBatchEditData">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
// import * as utils from 'src/utils'
import { mapGetters } from 'vuex'

export default {
  created () {
    this.dialogVisible = true
    this.getBatchEditData()
  },
  props: {
    selectIds: {
      type: Array
    },
    templateId: {
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      fillter: {},
      fillterAlias: '',
      fillterDate: {},
      attrValue: ''
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ])
  },
  methods: {
    getBatchEditData () {
      let url = `/batchEditApi/getEditAttr.html`
      let params = {
        type: this.moduleName.replace('Api', ''),
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.fillterDate = data.result
      })
    },
    saveBatchEditData () {
      if (!this.attrValue) {
        Message('请编辑选项')
        return
      }
      let url = `/batchEditApi/editAttr.html`
      let params = {
        ids: this.selectIds,
        attr: this.fillter.alias,
        attrValue: this.attrValue,
        isRedundant: this.fillter.isRedundant,
        fieldType: this.fillter.fieldType,
        required: this.fillter.required,
        type: this.moduleName.replace('Api', ''),
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        let that = this
        Message({
          type: 'success',
          message: data.msg,
          duration: 1000,
          onClose: function () {
            that.dialogVisible = false
            that.$emit('refresh')
          }
        })
      })
    },
    changeFillter (alias) {
      for (let i in this.fillterDate) {
        if (this.fillterDate[i].alias === alias) {
          this.fillter = this.fillterDate[i]
          this.attrValue = ''
          return
        }
      }
    }
  },
  watch: {
    dialogVisible () {
      if (!this.dialogVisible) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .batch-edit .el-dialog--small {
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// batch-edit.vue?9598f686